import React from "react";
const BaseUrl = "https://irluxe-smart.ir";
const apiUrl = BaseUrl + "/api/v1/";
export { apiUrl };
